module.exports = __webpack_public_path__ + "images/sprites/ui/icon_tag_pin_b211ab087e719537c85c6c6edd663a27.png";